import useProductVariant from '@/api/inventory-management/products/useProductVariant';
import { RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';
import { XCircleIcon } from '@phosphor-icons/react';

export function ProductVariantListItem({
  variantId,
  isSelected,
  onSelect,
}: {
  variantId: string;
  isSelected: boolean;
  onSelect: (variantId: string, productId: string) => void;
}) {
  const { data, isLoading, error } = useProductVariant(variantId);
  const productVariant = data?.productVariant;

  return (
    <li
      className="border-b last:border-b-0"
      onClick={() => {
        if (productVariant) {
          onSelect(productVariant.id, productVariant.productId);
        }
      }}
    >
      <Label className="flex items-center p-1 gap-1">
        <RadioGroupItem value={variantId} checked={isSelected} />
        {isLoading ? (
          <Skeleton className="w-full" />
        ) : error ? (
          <>
            <XCircleIcon className="text-destructive" />
            <span className="text-destructive">
              {error.message || 'Error loading variant'}
            </span>
          </>
        ) : productVariant ? (
          <span>
            {(productVariant.originMetadata?.NAMEINVC as string) || '(No name)'}
          </span>
        ) : (
          <span>Variant not found</span>
        )}
      </Label>
    </li>
  );
}
